// const plans = [
//   {
//     badge: "Starter",
//     name: "Launch",
//     tagline: "Get online fast. Everything you need to start selling.",
//     price: "₹18,000",
//     priceSub: "+ Shopify ~₹2,000/mo (billed by Shopify)",
//     delivery: "Delivered in 5 days",
//     themeTitle: "Free Shopify theme",
//     themeDesc:
//       "Dawn, Craft, or Sense - clean, fast-loading, mobile-ready themes handpicked for your business category.",
//     themeCost: "No extra cost",
//     customization: [
//       { text: "Brand colors applied", included: true },
//       { text: "Font pairing selected", included: true },
//       { text: "Logo placed throughout", included: true },
//       { text: "Homepage layout changes", included: false },
//       { text: "Custom banners & sections", included: false },
//       { text: "Liquid code edits", included: false },
//     ],
//     revision: "1 revision round included",
//     groups: [
//       {
//         label: "Store setup",
//         items: [
//           { text: "Full Shopify store setup", included: true },
//           { text: "Custom domain connection", included: true },
//           { text: "Up to 20 products listed", included: true },
//           { text: "UPI + card payment integration", included: true },
//           { text: "Basic SEO (title + meta)", included: true },
//         ],
//       },
//       {
//         label: "Brand & presence",
//         items: [
//           { text: "Logo design (1 concept)", included: true },
//           { text: "WhatsApp Business setup", included: true },
//           { text: "Social media account setup", included: false },
//           { text: "Meta Pixel", included: false },
//           { text: "Abandoned cart emails", included: false },
//         ],
//       },
//       {
//         label: "Support",
//         items: [
//           { text: "3 days post-launch support", included: true },
//           { text: "Store walkthrough video", included: true },
//         ],
//       },
//     ],
//     cta: "Start with Launch",
//     highlighted: false,
//   },
//   {
//     badge: "Most popular",
//     name: "Growth",
//     tagline: "Our most complete package. Built to sell from Day 1.",
//     price: "₹28,000",
//     priceSub: "+ Shopify ~₹2,000/mo (billed by Shopify)",
//     delivery: "Delivered in 7 days",
//     themeTitle: "Free Shopify theme - fully customised",
//     themeDesc:
//       "Same professional free themes but taken further - homepage layout restructured, custom banners designed, sections rearranged to match your brand story.",
//     themeCost: "No extra cost",
//     customization: [
//       { text: "Brand colors + font pairing", included: true },
//       { text: "Homepage layout restructured", included: true },
//       { text: "Custom banners & hero images", included: true },
//       { text: "Sections arranged per brand story", included: true },
//       { text: "Imagery placement & styling", included: true },
//       { text: "Liquid code level edits", included: false },
//     ],
//     revision: "2 revision rounds included",
//     groups: [
//       {
//         label: "Store setup",
//         items: [
//           { text: "Full Shopify store setup", included: true },
//           { text: "Custom domain connection", included: true },
//           { text: "Up to 40 products listed", included: true },
//           { text: "UPI + card + net banking payment", included: true },
//           {
//             text: "Full SEO setup (title, meta, speed, sitemap)",
//             included: true,
//           },
//           { text: "Meta Pixel integration", included: true },
//           { text: "Abandoned cart email setup", included: true },
//           { text: "Google Business Profile setup", included: true },
//         ],
//       },
//       {
//         label: "Brand & presence",
//         items: [
//           { text: "Logo design (2 concepts)", included: true },
//           { text: "WhatsApp Business setup", included: true },
//           { text: "Social media setup (2 platforms)", included: true },
//           { text: "Google Ads setup", included: false },
//           { text: "Instagram Shop integration", included: false },
//         ],
//       },
//       {
//         label: "Support",
//         items: [
//           { text: "7 days post-launch support", included: true },
//           { text: "Store walkthrough video", included: true },
//         ],
//       },
//     ],
//     cta: "Most Popular",
//     highlighted: true,
//   },
//   {
//     badge: "Premium",
//     name: "Scale",
//     tagline: "For businesses ready to grow aggressively online.",
//     price: "₹50,000",
//     priceSub:
//       "Includes premium Shopify theme (up to $100 USD) + Shopify ~₹2,000/mo",
//     delivery: "Delivered in 10 days",
//     themeTitle: "Premium paid Shopify theme",
//     themeDesc:
//       "We select the best paid theme for your industry - Prestige, Impulse, Symmetry, or similar. Richer features, more layout options, built-in conversion tools.",
//     themeCost: "Theme cost included - no extra charge",
//     customization: [
//       { text: "Full brand customisation", included: true },
//       { text: "Homepage layout from scratch", included: true },
//       { text: "Custom banners, hero & sections", included: true },
//       { text: "Imagery placement & styling", included: true },
//       { text: "Liquid code edits for unique layouts", included: true },
//       { text: "Custom typography & spacing", included: true },
//     ],
//     revision: "3 revision rounds included",
//     groups: [
//       {
//         label: "Store setup",
//         items: [
//           { text: "Everything in Growth", included: true },
//           { text: "Up to 80 products listed", included: true },
//           { text: "Instagram Shop integration", included: true },
//           { text: "Blog / content section setup", included: true },
//           { text: "Email capture + welcome flow automation", included: true },
//           { text: "Advanced SEO + Google Search Console", included: true },
//         ],
//       },
//       {
//         label: "Brand & presence",
//         items: [
//           { text: "Logo design (3 concepts + revisions)", included: true },
//           { text: "Social media setup (3 platforms)", included: true },
//           { text: "Google Ads basic setup", included: true },
//           { text: "WhatsApp Business setup", included: true },
//         ],
//       },
//       {
//         label: "Support",
//         items: [
//           { text: "14 days post-launch support", included: true },
//           { text: "Store walkthrough video", included: true },
//           { text: "1 month retainer included free", included: true },
//           { text: "Priority WhatsApp support", included: true },
//         ],
//       },
//     ],
//     cta: "Choose Scale",
//     highlighted: false,
//   },
// ];

// const retainers = [
//   {
//     name: "Basic",
//     price: "₹3,000/mo",
//     detail:
//       "Up to 8 product updates, banner changes, bug fixes, WhatsApp support",
//   },
//   {
//     name: "Standard",
//     price: "₹4,500/mo",
//     detail:
//       "Up to 20 updates, seasonal offers, performance check, priority support",
//   },
//   {
//     name: "Pro",
//     price: "₹6,500/mo",
//     detail:
//       "Unlimited updates, new page additions, monthly analytics report, same day support",
//   },
// ];

const plans = [
  {
    badge: "Starter",
    badgeClass: "badge-starter",
    name: "Launch",
    tagline: "Get online fast. Everything you need to start selling.",
    price: "₹18,000",
    priceSub: "+ Shopify ~₹2,000/mo (billed by Shopify)",
    delivery: "Delivered in 5 days",
    revision: "1 revision round included",
    groups: [
      {
        label: "Store setup",
        items: [
          { text: "Full Shopify store setup", included: true },
          { text: "Custom domain connection", included: true },
          { text: "Up to 20 products listed", included: true },
          { text: "UPI + card payment integration", included: true },
          { text: "Basic SEO (title + meta)", included: true },
        ],
      },
      {
        label: "Brand & presence",
        items: [
          { text: "Logo design (1 concept)", included: true },
          { text: "WhatsApp Business setup", included: true },
          // { text: "Social media account setup", included: false },
          // { text: "Meta Pixel", included: false },
          // { text: "Abandoned cart emails", included: false },
        ],
      },
      {
        label: "Support",
        items: [
          { text: "3 days post-launch support", included: true },
          { text: "Store walkthrough video", included: true },
        ],
      },
    ],
    cta: "Start with Launch",
    ctaClass: "btn-black",
    highlighted: false,
  },
  {
    badge: "Most popular",
    badgeClass: "badge-popular",
    name: "Growth",
    tagline: "Our most complete package. Built to sell from Day 1.",
    price: "₹28,000",
    priceSub: "+ Shopify ~₹2,000/mo (billed by Shopify)",
    delivery: "Delivered in 7 days",
    revision: "2 revision rounds included",
    groups: [
      {
        label: "Store setup",
        items: [
          { text: "Full Shopify store setup", included: true },
          { text: "Custom domain connection", included: true },
          { text: "Up to 40 products listed", included: true },
          { text: "UPI + card + net banking payment", included: true },
          {
            text: "Full SEO setup (title, meta, speed, sitemap)",
            included: true,
          },
          { text: "Meta Pixel integration", included: true },
          { text: "Abandoned cart email setup", included: true },
          { text: "Google Business Profile setup", included: true },
        ],
      },
      {
        label: "Brand & presence",
        items: [
          { text: "Logo design (2 concepts)", included: true },
          { text: "WhatsApp Business setup", included: true },
          { text: "Social media setup (2 platforms)", included: true },
          // { text: "Google Ads setup", included: false },
          // { text: "Instagram Shop integration", included: false },
        ],
      },
      {
        label: "Support",
        items: [
          { text: "7 days post-launch support", included: true },
          { text: "Store walkthrough video", included: true },
        ],
      },
    ],
    cta: "Most Popular",
    ctaClass: "btn-color-a",
    highlighted: true,
  },
  {
    badge: "Premium",
    badgeClass: "badge-premium",
    name: "Scale",
    tagline: "For businesses ready to grow aggressively online.",
    price: "₹50,000",
    priceSub:
      "Includes premium Shopify theme (up to $100 USD) + Shopify ~₹2,000/mo",
    delivery: "Delivered in 10 days",
    revision: "3 revision rounds included",
    groups: [
      {
        label: "Store setup",
        items: [
          { text: "Everything in Growth", included: true },
          { text: "Up to 80 products listed", included: true },
          { text: "Instagram Shop integration", included: true },
          { text: "Blog / content section setup", included: true },
          { text: "Email capture + welcome flow automation", included: true },
          { text: "Advanced SEO + Google Search Console", included: true },
        ],
      },
      {
        label: "Brand & presence",
        items: [
          { text: "Logo design (3 concepts + revisions)", included: true },
          { text: "Social media setup (3 platforms)", included: true },
          { text: "Google Ads basic setup", included: true },
          { text: "WhatsApp Business setup", included: true },
        ],
      },
      {
        label: "Support",
        items: [
          { text: "14 days post-launch support", included: true },
          { text: "Store walkthrough video", included: true },
          { text: "1 month retainer included free", included: true },
          { text: "Priority WhatsApp support", included: true },
        ],
      },
    ],
    cta: "Choose Scale",
    ctaClass: "btn-black",
    highlighted: false,
  },
];

const retainers = [
  {
    name: "Basic",
    price: "₹3,000/mo",
    detail:
      "Up to 8 product updates, banner changes, bug fixes, WhatsApp support",
  },
  {
    name: "Standard",
    price: "₹4,500/mo",
    detail:
      "Up to 20 updates, seasonal offers, performance check, priority support",
  },
  {
    name: "Pro",
    price: "₹6,500/mo",
    detail:
      "Unlimited updates, new page additions, monthly analytics report, same day support",
  },
];

export default function PricingSection() {
  return (
    <section id="pricing" className="ptb ptb-sm-80">
      <div className="container text-center">
        <h3>Pricing Table</h3>
        <div className="spacer-60" />
        <div className="row">
          {plans.map((plan) => (
            <div className="col-md-4" key={plan.name}>
              <div
                className={`Pricing-box${plan.highlighted ? " highlight" : ""}`}
              >
                {/* Title */}
                <div className="price-title spacing-box">
                  <span className={`badge ${plan.badgeClass}`}>
                    {plan.badge}
                  </span>
                  <h4>{plan.name}</h4>
                  <p className="price-tagline">{plan.tagline}</p>
                </div>

                <hr />

                {/* Price */}
                <div className="spacing-box">
                  <div className="price">{plan.price}</div>
                  <div className="price-sub">{plan.priceSub}</div>
                  <div className="price-delivery">{plan.delivery}</div>
                </div>

                <hr />

                {/* Feature Groups */}
                <div className="pricing-features">
                  {plan.groups.map((group) => (
                    <div key={group.label}>
                      <div className="group-label">{group.label}</div>
                      <ul>
                        {group.items.map((item) => (
                          <li
                            key={item.text}
                            className={!item.included ? "faded" : ""}
                          >
                            <span className={item.included ? "check" : "cross"}>
                              {item.included ? "✓" : "✗"}
                            </span>
                            {item.text}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>

                <hr />

                {/* Revision */}
                <div className="spacing-box">
                  <div className="revision">{plan.revision}</div>
                </div>

                <hr />

                {/* CTA */}
                <div className="spacing-grid">
                  <a className={`btn btn-md ${plan.ctaClass}`}>{plan.cta}</a>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* Retainer Section */}
        <div className="spacer-60" />
        <h3>Monthly Retainer Plans</h3>
        <p className="lead gray">Keep your store fresh — without the hassle.</p>
        <div className="spacer-30" />
        <div className="row">
          {retainers.map((r) => (
            <div className="col-md-4" key={r.name}>
              <div className="Pricing-box">
                <div className="price-title spacing-box">
                  <h4>{r.name}</h4>
                </div>
                <hr />
                <div className="spacing-box">
                  <div className="price">
                    <span className="price-lg">{r.price}</span>
                  </div>
                </div>
                <hr />
                <div className="pricing-features spacing-grid">
                  <p className="retainer-detail">{r.detail}</p>
                </div>
                <hr />
                <div className="spacing-grid">
                  <a className="btn btn-md btn-black">Get Started</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
